import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=1a76bed0&scoped=true&"
import script from "./Notices.vue?vue&type=script&lang=js&"
export * from "./Notices.vue?vue&type=script&lang=js&"
import style0 from "./Notices.vue?vue&type=style&index=0&id=1a76bed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a76bed0",
  null
  
)

export default component.exports